import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import monitor from "csi/monitor/_base";
import sessionConstants from "csi/sessionConstants";
import { C8Node } from "csi/typings";
import MaterialIcon from "csi/widget/MaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const UpdateStatusRenderer = declare(StringRen, {

	/**
	 * @override
	 * Render icon if source bom and linkeddUpdateStatus is UpdatedByHost or UpdatedBySource
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement) {
		const rendered = this.inherited(arguments);
		const currentBOM = ctx.getNode();


		if (!xml.isValidURL(currentBOM?.LinkedHostDataSheet)) {
			return rendered;
		}

		const bomRevCnl = currentBOM.CurrentRevision;
		const bomRev = ctx.cache.getNode(bomRevCnl);
		const linkedBOMUpdateStatus = bomRev?.LinkedBOMUpdateStatus;
		const displayDot = this.shouldDisplayDot(linkedBOMUpdateStatus);

		if (displayDot) {
			this.renderIcon(refNode);
		}

		this.setupNodeMonitor(ctx, refNode, bomRev, displayDot);

		return rendered;
	},

	/**
	 * Check if the dot should be displayed
	 */
	shouldDisplayDot(linkedBOMUpdateStatus: string | undefined): boolean {
		const { isSupplierUser, userSupplierUrl } = sessionConstants;
		const isSupplier = isSupplierUser || userSupplierUrl;

		if (linkedBOMUpdateStatus) {
			if (isSupplier) {
				return linkedBOMUpdateStatus === "LinkedBOMUpdateStatus:UpdatedByHost";
			} else {
				return linkedBOMUpdateStatus === "LinkedBOMUpdateStatus:UpdatedBySource";
			}
		}

		return false;
	},

	/**
	 * Render the dot icon
	 */
	renderIcon(refNode: HTMLElement): void {
		new MaterialIcon({
			icon: "circle",
			style: "cursor: initial; margin-right: 10px; margin-bottom: 2px; color: #3C94F0; font-size: small",
		}).placeAt(refNode, "first");
	},

	/**
	 * Setup a node monitor to update the view when the LinkedBOMUpdateStatus changes
	 */
	setupNodeMonitor(ctx: Context, refNode: HTMLElement, bomRev: C8Node, isDotDisplayed: boolean): void {
		monitor.onChangeNode(bomRev, (node) => {
			ctx.cache.add(node);
			if (this.shouldDisplayDot(node.LinkedBOMUpdateStatus) || isDotDisplayed) {
				ctx.view.redrawNode(refNode);
			}
		});
	},
});

export = UpdateStatusRenderer;
